import { FC, ReactNode, useEffect, useRef, useState } from 'react';
import { Box, Typography } from '@mui/material';

interface ConditionalGlowProps {
  children: ReactNode;
  isNewlyRevealed: boolean;
  origin?: { questionName: string; choiceName: string } | null;
}

const ConditionalGlow: FC<ConditionalGlowProps> = ({
  children,
  isNewlyRevealed,
  origin,
}) => {
  const [showGlow, setShowGlow] = useState(false);
  const hasGlowedRef = useRef(false);

  useEffect(() => {
    if (isNewlyRevealed && !hasGlowedRef.current) {
      hasGlowedRef.current = true;
      setShowGlow(true);
      const timer = setTimeout(() => {
        setShowGlow(false);
      }, 3000);
      return () => {
        clearTimeout(timer);
      };
    }
  }, [isNewlyRevealed]);

  return (
    <Box
      sx={{
        borderRadius: 1,
        transition: 'box-shadow 0.5s ease-in-out',
        ...(showGlow && {
          boxShadow: '0 0 12px 2px rgba(25, 118, 210, 0.35)',
        }),
      }}
    >
      {showGlow && origin && (
        <Typography
          variant="caption"
          sx={{
            display: 'block',
            px: 1.5,
            pt: 1,
            color: 'info.main',
            fontStyle: 'italic',
          }}
        >
          Appeared because you answered &ldquo;{origin.choiceName}&rdquo; on
          &ldquo;{origin.questionName}&rdquo;
        </Typography>
      )}
      {children}
    </Box>
  );
};

export default ConditionalGlow;
